import { postData } from "../Services/postData";

/**
 * Upload logo for any entity (location, brand, etc.)
 * @param file - The logo file to upload
 * @param entityData - The complete entity object (location, brand, etc.)
 * @param apiEndpoint - The API endpoint for the entity (e.g., "api/locatii-administrative")
 * @returns Promise with the API response
 */
export const uploadEntityLogo = async (
  file: File,
  entityData: Record<string, any>,
  apiEndpoint: string
) => {
  const formData = new FormData();

  // Append all entity fields dynamically
  Object.keys(entityData).forEach((key) => {
    if (entityData[key] !== null && entityData[key] !== undefined) {
      formData.append(key, entityData[key]);
    }
  });

  // Append logo file
  formData.append("logo", file);
  formData.append("_method", "PUT");

  const response = await postData(`/${apiEndpoint}/${entityData.id}`, formData);

  return response;
};

/**
 * Create FormData from an object
 * @param data - Object to convert to FormData
 * @returns FormData instance
 */
export const objectToFormData = (data: Record<string, any>): FormData => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  });

  return formData;
};
